import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Form from '../../components/forms/InfoBannerForm';
import { saveBanner, withRedirect } from '../../CroActions';
import { breadcrumbs } from '../../../../actions/appActions';

const mapStateToProps = (state, { params }) => ({
    breadcrumbsItems: [{ label: 'Správa upozornění' }, { label: 'Editace upozornění' }],
    url: `/administrator/api/info-banner/${params.id}`,
    postProcess: (data) => {
        const result = { ...data };
        if (data.targetRoles) {
            data.targetRoles.forEach(role => {
                result[`role_${role}`] = true;
            });
        }
        if (data.validFrom) result.validFrom = new Date(data.validFrom);
        if (data.validTo) result.validTo = new Date(data.validTo);
        return result;
    },
});

const mapDispatchToProps = (dispatch) => {
    const onSubmitRedirect = withRedirect(saveBanner, '/administrator/upozorneni');
    return {
        ...bindActionCreators({ breadcrumbs }, dispatch),
        onSubmit: (data) => dispatch(onSubmitRedirect(data)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Form);